var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-row align-center"},[_c('v-btn',{staticClass:"text-capitalize mr-3",attrs:{"outlined":""},on:{"click":function($event){return _vm.loadWithNoPayout()}}},[_vm._v("Load No Payouts")]),_c('MonthSelector',{on:{"select":_vm.select}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }